import { createAsyncThunk } from '@reduxjs/toolkit';

import { SecondaryMarketService } from 'api';

import { SortPaginationParams } from 'models';

export const getSecondaryMarketItems = createAsyncThunk(
	'secondaryMarket/getSecondaryMarketItems',
	async (params: SortPaginationParams) => {
		return await SecondaryMarketService.getAll(params);
	},
);
